export enum EAccreditationType {
  REQUEST = 'REQUEST',
  ORDER = 'ORDER',
  LOGISTICS = 'LOGISTICS',
}
